import React, {Component} from "react";
import {connect} from 'react-redux'

class FJAdsorptionContainer extends Component {
  render() {
    const {adsorptionLineHorizontalValues, FJAdsorptionLine, className} = this.props;
    return (
      !!adsorptionLineHorizontalValues.length && adsorptionLineHorizontalValues.map(value => <FJAdsorptionLine
        className={className} key={value} left={value}/>)
    );
  }
}

const mapStateToProps = function (state) {
  return {
    adsorptionLineHorizontalValues: state.timeline.adsorptionLineHorizontalValues,
  }
};

export default connect(mapStateToProps, null)(FJAdsorptionContainer);